<template>
    <div class="text-editor-skeleton">
        <div class="skeleton-toolbar" v-if="showToolbar">
            <div class="skeleton-toolbar-group">
                <div class="skeleton-button"></div>
                <div class="skeleton-button"></div>
                <div class="skeleton-select"></div>
                <div class="skeleton-button"></div>
                <div class="skeleton-button"></div>
                <div class="skeleton-button"></div>
                <div class="skeleton-button"></div>
                <div class="skeleton-button"></div>
            </div>
        </div>
        <div class="skeleton-content">
            <div class="skeleton-line" style="width: 40%"></div>
            <div class="skeleton-line" style="width: 90%"></div>
            <div class="skeleton-line" style="width: 85%"></div>
            <div class="skeleton-line" style="width: 92%"></div>
            <div class="skeleton-line" style="width: 78%"></div>
            <div class="skeleton-line" style="width: 88%"></div>
            <div class="skeleton-line" style="width: 50%"></div>
            <div class="skeleton-spacer"></div>
            <div class="skeleton-line" style="width: 95%"></div>
            <div class="skeleton-line" style="width: 87%"></div>
            <div class="skeleton-line" style="width: 91%"></div>
            <div class="skeleton-line" style="width: 83%"></div>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    showToolbar?: boolean;
}>();
</script>

<style lang="scss" scoped>
.text-editor-skeleton {
    background-color: #ffffff;
    border-radius: 0.25rem;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.skeleton-toolbar {
    background-color: #f5f5f5;
    border-bottom: 1px solid #dbdbdb;
    padding: 0.5rem;
    display: flex;
    align-items: center;
}

.skeleton-toolbar-group {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}

.skeleton-button {
    width: 32px;
    height: 32px;
    background: linear-gradient(90deg, #ebebeb 25%, #f5f5f5 50%, #ebebeb 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 0.25rem;
}

.skeleton-select {
    width: 120px;
    height: 32px;
    background: linear-gradient(90deg, #ebebeb 25%, #f5f5f5 50%, #ebebeb 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 0.25rem;
}

.skeleton-content {
    padding: 1rem;
    flex: 1;
    overflow: hidden;
}

.skeleton-line {
    height: 16px;
    background: linear-gradient(90deg, #ebebeb 25%, #f5f5f5 50%, #ebebeb 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 4px;
    margin-bottom: 0.75rem;
}

.skeleton-spacer {
    height: 1.5rem;
}

@keyframes shimmer {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}
</style>
